export default function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-[#0F6B4F]/20 bg-white px-6 py-14 text-center" data-testid={testId || "empty-state"}>
      {Icon && (
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#F5F9F7] text-[#0F6B4F]">
          <Icon className="h-7 w-7" />
        </div>
      )}
      <h3 className="font-heading text-lg font-semibold text-[#1F2937]">{title}</h3>
      {description && <p className="max-w-sm text-sm text-[#64748B]">{description}</p>}
      {action}
    </div>
  );
}
